module.exports = __webpack_public_path__ + "img/aParty_032523_F.e79dab5d.jpg";